import React from "react";

// Data for Case Studies
const stories = [
  {
    id: 1,
    industry: "Fintech",
    title: "Secure Money Exchange Database",
    client: "Global Currency Exchange",
    desc: "Developed a high-frequency transaction engine capable of handling 10k+ transactions/sec with military-grade encryption.",
    image:
      "https://images.unsplash.com/photo-1642543492481-44e81e3914a7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 2,
    industry: "Education",
    title: "Modern School Portal",
    client: "Greenwood Academy",
    desc: "Redesigned the entire digital experience for students and parents, including online payments and grade tracking.",
    image:
      "https://plus.unsplash.com/premium_photo-1661963599488-8eae5e3675df?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 3,
    industry: "Healthcare",
    title: "Clinic Management System",
    client: "1 Clinic",
    desc: "Unified patient records, appointment booking, and pharmacy stock management into a single dashboard.",
    image:
      "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  },
];

// --- Reusable Case Study Item Component ---
const CaseStudyItem = ({ story }) => (
  <div className="flex flex-col md:flex-row bg-slate-50 rounded-3xl overflow-hidden border border-slate-200 shadow-sm hover:shadow-xl transition-all duration-300 group">
    {/* Image Side */}
    <div className="md:w-1/2 w-full h-64 md:h-auto relative overflow-hidden">
      <img
        src={story.image}
        alt={story.title}
        className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
      />
      {/* Overlay on Image */}
      <div className="absolute inset-0 bg-slate-900/20 group-hover:bg-slate-900/10 transition-colors duration-300"></div>
    </div>

    {/* Content Side */}
    <div className="md:w-1/2 w-full p-8 md:p-12 flex flex-col justify-center">
      {/* Industry Tag */}
      <span className="inline-block w-max px-3 py-1 rounded-full bg-indigo-100 text-blue-700 text-xs font-bold uppercase tracking-widest mb-4">
        {story.industry}
      </span>

      {/* Client Name */}
      <span className="text-sm text-slate-500 font-medium mb-2">
        Client: {story.client}
      </span>

      {/* Title */}
      <h3 className="text-2xl md:text-3xl font-bold mb-4 text-slate-900 leading-tight group-hover:text-blue-600 transition-colors">
        {story.title}
      </h3>

      {/* Description */}
      <p className="text-slate-600 leading-relaxed mb-8">{story.desc}</p>

      {/* Link */}
      <a
        href="#"
        className="text-blue-600 font-bold flex items-center gap-2 group/link"
      >
        View Case Study
        <svg
          className="w-4 h-4 transform group-hover/link:translate-x-1 transition-transform"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M17 8l4 4m0 0l-4 4m4-4H3"
          />
        </svg>
      </a>
    </div>
  </div>
);

const SuccessStoriesSection = () => {
  return (
    <section className="pb-10 bg-white text-slate-900">
      <div className="container mx-auto px-6 max-w-screen-xl">
        {/* --- Section Header --- */}
        <div className="mb-16">
          <span className="text-blue-600 font-bold tracking-wider uppercase text-xs">
            Our Work
          </span>
          <h2 className="text-3xl md:text-5xl font-bold mt-2 text-slate-900">
            Success Stories
          </h2>
        </div>

        {/* --- List of Case Studies --- */}
        <div className="space-y-12">
          {stories.map((story) => (
            <CaseStudyItem key={story.id} story={story} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default SuccessStoriesSection;
